import React from 'react';
import { BrowserRouter as Router, Routes, Route,Navigate } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import PGMallHomepage from './pgmall-homepage';
import ProductListPage from './product-list-page';
import ProductDetailPage from './product-detail-page';
import ShoppingCartPage from './shopping-cart-page';
import AuthPage from './auth-page';
import FavoritesPage from './favorites-page';
import ProfilePage from './profilepage';
import OrdersPage from './orders-page';
// 管理者後台頁面
import AdminLogin from './admin-login';
import AdminSettings from './admin-settings'
import AdminDashboard from './admin-dashboard';
import AdminSellerForm from './admin-seller-form';
import AdminSellerProducts from './admin-seller-products';
import AdminProductForm from './admin-product-form';

// 私有路由組件 - 需要登入才能訪問（一般用戶）
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/auth" />;
};

// 管理員路由組件 - 需要管理員權限
const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const adminRole = localStorage.getItem('adminRole');
  
  // 檢查是否有 token 和管理員角色
  if (!token || !adminRole) {
    return <Navigate to="/admin/login" />;
  }
  
  return children;
};

function App() {
  return (
    <CartProvider>
      <Router basename="/">
        <Routes>
          {/* 使用者登入端 */}
          <Route path="/" element={<PGMallHomepage />} />
          <Route path="/products" element={<ProductListPage />} />
          <Route path="/product/:id" element={<ProductDetailPage />} />
          {/* ✨ 修改：移除 PrivateRoute，允許未登入訪問購物車 */}
          <Route path="/cart" element={<ShoppingCartPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/favorites" element={<PrivateRoute><FavoritesPage /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
          <Route path="/orders" element={<PrivateRoute><OrdersPage /></PrivateRoute>} />
          {/* 後臺登入端 */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/settings" element={<AdminRoute><AdminSettings /></AdminRoute>} />
          <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/admin/sellers/new" element={<AdminRoute><AdminSellerForm /></AdminRoute>} />
          <Route path="/admin/sellers/:id/edit" element={<AdminRoute><AdminSellerForm /></AdminRoute>} />
          <Route path="/admin/sellers/:sellerId/products" element={<AdminRoute><AdminSellerProducts /></AdminRoute>} />
          <Route path="/admin/products/new" element={<AdminRoute><AdminProductForm /></AdminRoute>} />
          <Route path="/admin/products/:id/edit" element={<AdminRoute><AdminProductForm /></AdminRoute>} />

        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;